import { createBrowserClient } from "@supabase/ssr";
import { supabasePublishableKey, supabaseUrl } from "./supabase";

function useSupabaseBrowser() {
  return createBrowserClient(supabaseUrl || "", supabasePublishableKey || "", {
    realtime: {
      params: {
        eventsPerSecond: 1
      }
    }
  });
}

export default useSupabaseBrowser;
